/* eslint-disable camelcase */
import React, { useState, useEffect, useCallback, useContext } from 'react';
import _ from 'lodash';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import PropTypes from 'prop-types';
import appConfig from 'app-config';
import { UserService, MLUWService } from 'gw-capability-gateway';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { MLLocalDateUtil } from 'ml-portals-util-js';
import {MLModalService, MLTagManagerService } from 'ml-portals-services-react'
import { MLNotificationBlockUtil } from 'ml-portals-util-react';
import metadata from './MLUWIssuesPanelComponent.metadata.json5';
import messages from './MLUWIssuesPanelComponent.messages';
import styles from './MLUWIssuesPanelComponent.module.scss';
//DeclinePopUp Import
import { InlineNotification } from '@jutro/components';
import { useModal } from '@jutro/components';
import { FormModalPopover, platformMessages } from 'ml-components-platform-react';
import MLDeclineQuoteConfirmationComponent from '../MLDeclineQuoteConfirmationComponent/MLDeclineQuoteConfirmationComponent';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';
import { GatewayDocumentService } from 'gw-capability-gateway-document';
import { MLOnDemandDocumentService } from 'gw-capability-gateway';
//email Popup
import { MLAlertGroupComponent } from 'ml-components-common-react';
import emailAddressModalPopup from './EmailAddressModalPopup.metadata.json5';
import { AccountService } from 'gw-capability-gateway-policy';

//US993539
import MLDocumentsUpload from 'gw-capability-gateway-react/Policies/MLDocumentsUploadPopup/GatewayMLDocumentsUploadPopup';
import MLDocumentsUploadPopupMsg from 'gw-capability-gateway-react/Policies/MLDocumentsUploadPopup/MLDocumentsUploadPopup.messages';
import mlDocumentsUploadPopupMetadata from 'gw-capability-gateway-react/Policies/MLDocumentsUploadPopup/MLDocumentsUploadPopup.metadata.json5';
import { EndorsementService } from 'gw-capability-policychange';

import {  ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
const {
    MLUWIssuesBlockingPoints,
    MLUserTypes
} = appConfig;

function MLUWIssuesPanelComponent(props) {
    const { 
        uwIssues,
        jobID,
        publicID,
        hideIfAllApproved,
        rejectedIssuesAreQuoteBlocking,
        wrapped,
        showIssuesForBundle,
        refreshBundleUwIssues,
        approvedAllQuoteBlockingUwIssuesCallback,
        approvedAllBlockingUWIssuesCallback,
        blockingUWIssuesPresentCallback,
        setQuoteVisible,
        afterIssuesRefreshedCallback,
        submissionVM,
        updateWizardData,
        history,
        setIsFileUploadDone,
        FromAvailableDocuments,
        pendingContingencies
    } = props;
    //Decline Pop up
    const modalApi = useModal();
    const quoteID = _.get(submissionVM, 'quoteID.value');
    const baseState = _.get(submissionVM, "baseData.policyAddress.state.value.code");

    const translator = useTranslator();
    const { authHeader } = useAuthentication();
    const {
        clearBlockAlerts,
        addErrorAlert,
        getNumberOfAlertsExcludingBlocks,
        clearAlerts,
        clearErrorAlerts,
        addWarningAlert
    } = MLNotificationBlockUtil();

    const {
        showErrorModal,
        showProgressDialog,
        hideProgressDialog
    } = MLModalService();


    const [stateUwIssues, setStateUwIssues] = useState(uwIssues);
    const [isUWIssuesPanelVisible, setIsUWIssuesPanelVisible] = useState(true);
    const [showRefreshLoading, setShowRefreshLoading] = useState(false);
    const [user, setUser] = useState({});
    const [hadNonApprovedQuoteBlockingIssues, setHadNonApprovedQuoteBlockingIssues] = useState(false);
    const  isVisibleReadToCustomer = ['TX','AK'];
    const  isVisibleReadToCustomerTX = ['TX'];
    const [isFromAvailableDocuments, setIsFromAvailableDocuments] = useState(FromAvailableDocuments);
    
    const initialContingencies = (submissionVM?.value?.preBindContingenciesToDTO?.length > 0 ? submissionVM.value.preBindContingenciesToDTO : pendingContingencies) ?? [];

    //US993539
    const [contingencies, setcontingencies] = useState(initialContingencies);

    const viewModelService = useContext(ViewModelServiceContext);
    if(contingencies.length>0){
        if (typeof setIsFileUploadDone === 'function') {
            setIsFileUploadDone(true);
        }
    }
    else{
        if (typeof setIsFileUploadDone === 'function') {
            setIsFileUploadDone(false);
        }
    }
    // UWIssues UWIssueDTO logic
    const isBlockingUWIssue = (uwIssue) => {
        return uwIssue.currentBlockingPoint !== MLUWIssuesBlockingPoints.NON_BLOCKING;
    };

    const isDeclineInBatch_ML = (uwIssue) => {
        return stateUwIssues.filter((uwIssue) => uwIssue.isDeclineInBatch_ML ===true);
    };

    const isQuoteBlockingUWIssue = (uwIssue) => {
        return uwIssue.currentBlockingPoint === MLUWIssuesBlockingPoints.BLOCKS_QUOTE;
    };

    const wasBlockingQuote = (uwIssue) => {
        return uwIssue.initialBlockingPoint_ML === MLUWIssuesBlockingPoints.BLOCKS_QUOTE;
    };

    const isApprovedUWIssue = (uwIssue) => {
        return uwIssue.hasApprovalOrRejection && !isBlockingUWIssue(uwIssue);
    };

    const isRejectedUWIssue = (uwIssue) => {
        return uwIssue.hasApprovalOrRejection && uwIssue.currentBlockingPoint === MLUWIssuesBlockingPoints.REJECTED;
    };

    const hasBeenApprovedOrRejected = (uwIssue) => {
        return isApprovedUWIssue(uwIssue) || isRejectedUWIssue(uwIssue);
    };

    const hasWrapper = () => {
        return !_.isNil(wrapped);
    };

    const getUWIssueApprovalRejectionText = (uwIssue) => {
        if (uwIssue.approvalOrRejectionUWName_ML && uwIssue.approvalOrRejectionDate_ML) {
            const approvalOrRejectionDate = MLLocalDateUtil.localDate2Date(uwIssue.approvalOrRejectionDate_ML);

            return (
                <FormattedMessage
                    {...messages.approvedRejectedOnDate}
                    values={{
                        approvedOrRejected: <strong>{isApprovedUWIssue(uwIssue) ? translator(messages.approved) : translator(messages.rejected)}</strong>,
                        name: uwIssue.approvalOrRejectionUWName_ML,
                        date: approvalOrRejectionDate?.toLocaleDateString()
                    }}
                />
            )

        }
        return null;
    };

    const hasUWIssues = () => {
        return stateUwIssues.length > 0;
    };

    // Note: blocking issues include rejected ones
    const getApprovedOrBlockingUWIssues = useCallback(() => {
        return stateUwIssues.filter((uwIssue) => isApprovedUWIssue(uwIssue) || isBlockingUWIssue(uwIssue))
            .sort((a, b) => a.longDescription > b.longDescription);
    }, [isApprovedUWIssue, stateUwIssues]);

    const hasNonApprovedUWIssues = () => {
        return hasUWIssues()
                && getApprovedOrBlockingUWIssues().some((uwIssue) => !isApprovedUWIssue(uwIssue));
    };

    const showColoradoExclusion = () => {
        return baseState === "CO" && stateUwIssues.some(uwIssue => {
            const issueKey = uwIssue.issueKey_ML;

            const isTargetIssue =
                issueKey.startsWith("AIT") ||
                issueKey.includes("BR10106");

            return isTargetIssue && !isApprovedUWIssue(uwIssue);
        });
    }

    const showUwIssuesNonRefer = stateUwIssues.filter((uwIssue) => uwIssue.shortDescription === 'NONREFERMSG').length > 0;
    const showUwIssuesRefer = stateUwIssues.filter((uwIssue) => uwIssue.shortDescription === 'REFERMSG').length > 0;
    const hidePanel = hideIfAllApproved && !hasNonApprovedUWIssues();

    const hasNonApprovedQuoteBlockingUWIssues = useCallback(() => {
        const approvedBlockingUwIssues = getApprovedOrBlockingUWIssues();

        const hasQuoteBlockingIssuesPendingOrRejected = approvedBlockingUwIssues.some((uwIssue) => {
            return isQuoteBlockingUWIssue(uwIssue)
                || (wasBlockingQuote(uwIssue) && isRejectedUWIssue(uwIssue));
        });

        const hasOtherBlockingRejectedIssues = rejectedIssuesAreQuoteBlocking
            && approvedBlockingUwIssues.some((uwIssue) => isRejectedUWIssue(uwIssue));

        return !!hasQuoteBlockingIssuesPendingOrRejected || !!hasOtherBlockingRejectedIssues;
    }, [getApprovedOrBlockingUWIssues, rejectedIssuesAreQuoteBlocking]);

    const hasOpenUwIssues = () => {
        return hasUWIssues() && stateUwIssues.some((uwIssue) => !uwIssue.hasApprovalOrRejection);
    };

    const canApproveAllOpenUWIssues = () => {
        return !hasUWIssues()
                || getApprovedOrBlockingUWIssues().every((uwIssue) => uwIssue.canBeApprovedByUser_ML);
    };

    // UWIssues QuoteDTO logic
    const canApproveAllIssues = () => {
        return hasOpenUwIssues()
            && canApproveAllOpenUWIssues();
    };

    const isIAorPCSAgent = () => {
        return !_.isNil(user)
            && (user.userType === MLUserTypes.IA
            || user.userType === MLUserTypes.PCS);
    };

    const isIAorPCSorMetGAAgent = () => {
        return !_.isNil(user)
            && (user.userType === MLUserTypes.IA
            || user.userType === MLUserTypes.PCS
            || user.userType === MLUserTypes.MET_GA);
    };

    const getBlockingUWIssues = () => {
        return stateUwIssues.filter((uwIssue) => isBlockingUWIssue(uwIssue));
    };    

    const hasApprovedOrBlockingUWIssues = () => {
        return getApprovedOrBlockingUWIssues().length > 0;
    };

    const getQuoteBlockingUWIssues = () => {
        return stateUwIssues.filter((uwIssue) => isQuoteBlockingUWIssue(uwIssue));
    };        

    const toggleUWIssuesPanel = () => {
        setIsUWIssuesPanelVisible(!isUWIssuesPanelVisible);
    };

    const isReadToCustomerButtonEnabled = () => {
        return (user.userType === MLUserTypes.GCS_SALES) || (isVisibleReadToCustomer.includes(submissionVM?.value?.baseData?.policyAddress?.state))
    };
    const readForCustomerDisabledForTX = () => {
        return  (isVisibleReadToCustomerTX.includes(submissionVM?.value?.baseData?.policyAddress?.state)) || (user.userType === MLUserTypes.GCS_SALES);
    };
    // Handling of UW Issues logic
    const evaluateQuoteBlockingUWIssuesApprovals = () => {
        const localHasNonApprovedQuoteBlockingUWIssues = hasNonApprovedQuoteBlockingUWIssues();

        if (hadNonApprovedQuoteBlockingIssues && !localHasNonApprovedQuoteBlockingUWIssues) {
            setHadNonApprovedQuoteBlockingIssues(false);
            approvedAllQuoteBlockingUwIssuesCallback(publicID);
        }
    };

    const evaluateBlockingUWIssuesApprovals = () => {
        if (!hasNonApprovedUWIssues()) {
            approvedAllBlockingUWIssuesCallback(publicID);
        } else {
            blockingUWIssuesPresentCallback(publicID);
        }
    };

    const removeUnexistingUWIssues = (refreshedUWIssues) => {
        const issuesToRemove = [];

        stateUwIssues.forEach((uwIssue) => {
            const idx = refreshedUWIssues.findIndex((refreshedUWIssue) => {
                return refreshedUWIssue.issueKey_ML === uwIssue.issueKey_ML;
            });
            if (idx < 0) {
                issuesToRemove.push(uwIssue);
            }
        });

        issuesToRemove.forEach((removedIssue) => {
            const idx = stateUwIssues.findIndex((uwIssue) => uwIssue === removedIssue);
            if (idx >= 0) {
                stateUwIssues.splice(idx, 1);
            }
        });
    };

    const updateOrAddUWIssue = (issuesToUpdate, uwIssueKey, newUWIssue, isBundle) => {
        let idx;
        if (isBundle) {
            idx = issuesToUpdate.findIndex((uwIssue) => uwIssue.jobNumber === newUWIssue.jobNumber && uwIssue.issueKey_ML === uwIssueKey);
        } else {
            idx = issuesToUpdate.findIndex((uwIssue) => uwIssue.issueKey_ML === uwIssueKey);
        }
        if (idx >= 0) {
            issuesToUpdate[idx] = newUWIssue;
        } else {
            issuesToUpdate.push(newUWIssue);
        }
    };
    useEffect(()=>{
        if(isFromAvailableDocuments === true){
            refreshPreBindContingencyData();
            // disable it for not to reload 
            setIsFromAvailableDocuments (false);
        }
    },[contingencies]);

    useEffect(() => {
        if (setQuoteVisible && hasNonApprovedQuoteBlockingUWIssues()) {
            setQuoteVisible(false);
        }
    }, [stateUwIssues]);
    
    const refreshUWIssuesForSingleSubmission = () => {
        const uwIssueRequestDTO = {
            quoteID: jobID,
            publicID
        };
        setShowRefreshLoading(true);

        MLUWService.getUWIssues(uwIssueRequestDTO, authHeader).then((returnedIssues) => {
            setShowRefreshLoading(false);
            removeUnexistingUWIssues(returnedIssues);

            returnedIssues.forEach((uwIssue) => updateOrAddUWIssue(uwIssues, uwIssue.issueKey_ML, uwIssue));
            
            const issuesToUpdate = [...stateUwIssues];
            returnedIssues.forEach((uwIssue) => updateOrAddUWIssue(issuesToUpdate, uwIssue.issueKey_ML, uwIssue));
            setStateUwIssues(issuesToUpdate);

            if (afterIssuesRefreshedCallback) {
                afterIssuesRefreshedCallback(issuesToUpdate);
            }
        }, () => setShowRefreshLoading(false))
    };
        //refresh Pre Bind
        const refreshPreBindContingencyData = () => {
            //by Quote ID
            const jobNumber = submissionVM?.quoteID?.value;
            if(jobNumber){
                const loadPromise = LoadSaveService.refreshPreBindContingencies(jobNumber, authHeader);
                showProgressDialog(platformMessages.getPolicyDetails,  loadPromise);
                loadPromise.then((contingencyData) => {
                    if(contingencyData.length >0){
                        setcontingencies(contingencyData);
                        if (typeof setIsFileUploadDone === 'function') {
                            setIsFileUploadDone(true);
                        }
                    }
                    else {
                        setcontingencies([]);
                        if (typeof setIsFileUploadDone === 'function') {
                            setIsFileUploadDone(false);
                        }
                    }
                }).catch((error) => {
                    console.error(error);
                });
            } //by Policy number
            else{
                if(submissionVM !== undefined && submissionVM?.policyNumber?.value !== undefined){
                    const loadPromise = EndorsementService.refreshPreBindContingencies(submissionVM?.policyNumber?.value, authHeader);
                    showProgressDialog(platformMessages.getPolicyDetails,  loadPromise);
                    loadPromise.then((ContingencyData) => {
                        setcontingencies(ContingencyData);
                    }).catch((error) => {
                        console.error(error);
                    });
                }   
            }
        };

    const refreshOpenOrClosedPreBindContingencies = () => {
        const jobNumber = submissionVM?.quoteID?.value;

        if (jobNumber) {
            const loadPromise = LoadSaveService.refreshOpenOrClosedPreBindContingencies(jobNumber, authHeader);

            showProgressDialog(platformMessages.getPolicyDetails, loadPromise);
            loadPromise.then((contingencyData) => {
                if (updateWizardData) {
                    _.set(submissionVM, 'openOrClosedPreBindContingencies', contingencyData ?? [])
                    updateWizardData(submissionVM)
                }
            }).catch((error) => {
                console.error(error);
            });
        }
    }


    const refreshUWIssues = () => {
        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getFormName()}_Refresh UW issues`);
        setHadNonApprovedQuoteBlockingIssues(hasNonApprovedQuoteBlockingUWIssues());

        if (showIssuesForBundle) {
            refreshBundleUwIssues();
        } else {
            refreshUWIssuesForSingleSubmission();
        }
        refreshPreBindContingencyData();

        refreshOpenOrClosedPreBindContingencies();
    };

    const approveOrRejectUWIssue = (uwIssue, approve) => {
        setHadNonApprovedQuoteBlockingIssues(hasNonApprovedQuoteBlockingUWIssues());
        let localjobID = jobID;
        if (showIssuesForBundle) {
            localjobID = uwIssue.jobNumber;
        }

        const uwIssueRequestDTO = {
            quoteID: localjobID,
            publicID,
            issueKey: uwIssue.issueKey_ML,
            approveUWIssue: approve
        };
        const approveOrRejectPromise = MLUWService.approveOrRejectUWIssue(uwIssueRequestDTO, authHeader);
        uwIssue.showLoading = true;
        approveOrRejectPromise.then((updatedUWIssue) => {
            uwIssue.showLoading = false;
            if (showIssuesForBundle) {
                updatedUWIssue.jobNumber = localjobID;
            }
            
            updateOrAddUWIssue(uwIssues, uwIssue.issueKey_ML, updatedUWIssue, showIssuesForBundle);

            const issuesToUpdate = [...stateUwIssues];
            updateOrAddUWIssue(issuesToUpdate, uwIssue.issueKey_ML, updatedUWIssue, showIssuesForBundle);
            setStateUwIssues(issuesToUpdate);
        // eslint-disable-next-line no-return-assign
        }, () => uwIssue.showLoading = false);
    };

    const getUwIssuesWithoutReferrals = useCallback(() => {
        return stateUwIssues.filter((uwIssue) => uwIssue.shortDescription === 'NONREFERMSG');
    }, [stateUwIssues]);

    const getUwIssuesWithReferrals = useCallback(() => {
        return stateUwIssues.filter((uwIssue) => uwIssue.shortDescription === 'REFERMSG');
    }, [stateUwIssues]);

    const allUwIssuesWithoutReferralsApproved = useCallback(() => {
        const issues = getUwIssuesWithoutReferrals();
        return issues.length > 0 && issues.every((issue) => issue.hasApprovalOrRejection && !isBlockingUWIssue(issue));
    }, [getUwIssuesWithoutReferrals]);

    const allUwIssuesWithReferralsApproved = useCallback(() => {
        const issues = getUwIssuesWithReferrals();
        return issues.length > 0 && issues.every((issue) => issue.hasApprovalOrRejection && !isBlockingUWIssue(issue));
    }, [getUwIssuesWithReferrals]);

    const getSubmissionNumberPrefix = (subId) => {
        if (!subId) {
            return '';
        }
        const prefix = translator(messages.submissionPrefix);
        return `${prefix}${subId} - `;
    };

    const renderUWIssueText = (uwIssue) => {
        switch(uwIssue.issueKey_ML) {
            case "HOP:BR10037.gpa":
                return translator(messages.uwHOPBR10037, {
                    div: (chunks) => <div>{chunks}</div>,
                    br: () => <br />,
                    a: (chunks) => <a href="http://www.tdi.texas.gov/wind/index.html">{chunks}</a>
                })
            case "HOP:BR10064":
                return translator(messages.uwHOPBR10064, {
                    div: (chunks) => <div>{chunks}</div>,
                    a: (chunks) => <a href="http://www.nfipservices.com" target="_blank" rel="noreferrer">{chunks}</a>
                })
            case "HOP:BR10065":
                return translator(messages.uwHOPBR10065, {
                    div: (chunks) => <div>{chunks}</div>,
                    a: (chunks) => <a href="http://www.nfipservices.com" target="_blank" rel="noreferrer">{chunks}</a>
                })
            default:
                return uwIssue.longDescription
        }
    };
    

    useEffect(() => {
        UserService.getCurrentUser(authHeader).then((currentUser) => {
            setUser(currentUser);
        });
        evaluateBlockingUWIssuesApprovals();
        setHadNonApprovedQuoteBlockingIssues(hasNonApprovedQuoteBlockingUWIssues());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // evaluateAndEmit from v9 code, when UW issues are updated
    useEffect(() => {
        evaluateQuoteBlockingUWIssuesApprovals();
        evaluateBlockingUWIssuesApprovals();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stateUwIssues]);

    useEffect(() => {
        let issuesToUpdate = [...stateUwIssues];
        uwIssues.forEach((uwIssue) => {
            if (!uwIssue.hasApprovalOrRejection && !stateUwIssues.some((stateUwIssue) => stateUwIssue.issueKey_ML === uwIssue.issueKey_ML)) {
                updateOrAddUWIssue(issuesToUpdate, uwIssue.issueKey_ML, uwIssue, showIssuesForBundle);
            }
        });
        // Remove any UW Issue from StateUWISsues that's no longer in the original UW Issue list.
        // (Some UW Issues appears when selecting/deselecing certain coverages and will disappear after deselecting/selecting them again)
        const uwIssuesKeyList = uwIssues.map((uwIssue) => uwIssue.issueKey_ML)
        issuesToUpdate = issuesToUpdate.filter((stateUWIssue) => uwIssuesKeyList.includes(stateUWIssue.issueKey_ML));

        setStateUwIssues(issuesToUpdate.sort((a, b) => a.longDescription > b.longDescription));
    }, [uwIssues]);

    const generateNonReferredOverrides = () => {
        const overrides = getUwIssuesWithoutReferrals().map((uwIssue, index) => {
            return {
                [`showBundleIssues${index}`]: {
                    visible: showIssuesForBundle,
                    content: getSubmissionNumberPrefix(uwIssue.jobNumber)
                },
                [`actionsParentDiv${index}`]: {
                    visible: canApproveAllOpenUWIssues() && !hasBeenApprovedOrRejected(uwIssue)
                },
                [`loaderDiv${index}`]: {
                    visible: !!uwIssue.showLoading
                },
                [`nonLoadingUwIssue${index}`]: {
                    visible: !uwIssue.showLoading
                },
                [`approveBtn${index}`]: {
                    onClick: () => approveOrRejectUWIssue(uwIssue, true)
                },
                [`rejectBtn${index}`]: {
                    onClick: () => approveOrRejectUWIssue(uwIssue, false)
                },
                [`approvedOrRejectedP${index}`]: {
                    visible: hasBeenApprovedOrRejected(uwIssue),
                    content: getUWIssueApprovalRejectionText(uwIssue)
                },
                [`descrP${index}`]: {
                    content: renderUWIssueText(uwIssue)
                }
            }
        })
        return Object.assign({}, ...overrides);
    };

    const generateReferredOverrides = () => {
        const overrides = getUwIssuesWithReferrals().map((uwIssue, index) => {
            return {
                [`showBundleIssuesRefer${index}`]: {
                    visible: showIssuesForBundle,
                    content: getSubmissionNumberPrefix(uwIssue.jobNumber)
                },
                [`actionsParentDivRefer${index}`]: {
                    visible: canApproveAllOpenUWIssues() && !hasBeenApprovedOrRejected(uwIssue)
                },
                [`loaderDivRefer${index}`]: {
                    visible: !!uwIssue.showLoading
                },
                [`nonLoadingUwIssueRefer${index}`]: {
                    visible: !uwIssue.showLoading
                },
                [`approveBtnRefer${index}`]: {
                    onClick: () => approveOrRejectUWIssue(uwIssue, true)
                },
                [`rejectBtnRefer${index}`]: {
                    onClick: () => approveOrRejectUWIssue(uwIssue, false)
                },
                [`approvedOrRejectedPrefer${index}`]: {
                    visible: hasBeenApprovedOrRejected(uwIssue),
                    content: getUWIssueApprovalRejectionText(uwIssue)
                },
                [`descrPrefer${index}`]: {
                    content: renderUWIssueText(uwIssue)
                }
            }
        })
        return Object.assign({}, ...overrides);
    };

    //Decline Quote
    
    // Replacing DownloadDocumentService.getDocument functionality in order to change the filename at portal level. Just like v9 is doing.
    const downloadDocument = useCallback((url, doc) => {
        const httpPromise = fetch(url, authHeader);
        showProgressDialog(platformMessages.downloadingDocument, httpPromise);
        httpPromise.then((response) => {
            if (response.ok) {
                response.blob().then((blob) => {
                    const filename = `${doc.description}.pdf`;
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, filename);
                    } else {
                        const downloadLink = document.createElement('a');
                        downloadLink.setAttribute('href', window.URL.createObjectURL(blob));
                        downloadLink.setAttribute('download', filename);
                        downloadLink.style.display = 'none';
                        document.body.appendChild(downloadLink);
                        downloadLink.click();
                        downloadLink.remove();
                    }
                    history.push(`/accounts/${submissionVM?.baseData?.accountNumber?.value}/summary`);
                });
            } else {
                showErrorModal(platformMessages.error, platformMessages.unableToDownloadDocument);
            }
        });
        httpPromise.catch((error) => {
            console.error(error);
            showErrorModal(platformMessages.error, platformMessages.unableToDownloadDocument);
        });
    }, [authHeader, showErrorModal, showProgressDialog]);

    //Print Decline Quote Document
    const printQuote = useCallback((buttonOption) => {
         let emailId = null;
        if (buttonOption === 'emailNoticeButton') {
            emailId = _.get(submissionVM, 'baseData.primaryNamedInsured_ML.emailAddress1.value');
            if(emailId === undefined || emailId === ""){
                if(submissionVM?.baseData?.primaryNamedInsured_ML?.emailAddress1?.value)
                    {
                        submissionVM.baseData.primaryNamedInsured_ML.emailAddress1.value = " "
                    };
                return;
            }
        }

        const createOnDemandPromise = MLOnDemandDocumentService.generateAndSendOnDemandDocumentperiod(
            quoteID, true, emailId, true, authHeader);
            showProgressDialog(platformMessages.downloadingDocument, createOnDemandPromise);
            createOnDemandPromise.then((data) => {
            const docUid = data.docUID;
            const sessionId = data.sessionID;
            const publicId = data.publicID;
           if (docUid && buttonOption !== 'emailNoticeButton') {
                const resp = GatewayDocumentService.downloadDocument(publicId, sessionId);
                showProgressDialog(platformMessages.downloadingDocument, resp);
                resp.catch((error) => {
                    console.error(error);
                    showErrorModal(platformMessages.error, platformMessages.unableToDownloadDocument);
                });
            } else if(buttonOption !== 'emailNoticeButton'){
                showErrorModal(messages.error, messages.proposalError);
            }
            if(docUid && buttonOption === 'emailNoticeButton' ){
                history.push(`/accounts/${submissionVM?.baseData?.accountNumber?.value}/summary`);
            }
        }).catch((error) => {
            showErrorModal(platformMessages.error, platformMessages.unableToDownloadDocument);
        });
    }, [authHeader, quoteID, submissionVM, showErrorModal, showProgressDialog]);

    //Call Print Decline Quote Document
    const createProposalForAgentType = useCallback((buttonOption) => {
        printQuote(buttonOption);
    }, [printQuote]);

    //Generate  Decline Quote Document
    const onGenerateDeclineDocument = useCallback((buttonOption) => {
        const postUpdateCallback = createProposalForAgentType;
        postUpdateCallback(buttonOption);
    }, [createProposalForAgentType, submissionVM?.value]);
    
    //Send Decline Document via Email
    const saveEmailAddress = () => {
        showProgressDialog(messages.updatingDeclinestatus, /*updatePromise*/);
        return true;
    };
    
    //Validate Email Address
    const validateEmailAddress = (accountVm) => {
        const account = accountVm;
        let emailAddress1 =  _.get(account, 'emailAddress1.value');
        if(emailAddress1){
            emailAddress1 = emailAddress1.trim();
        }
        let isValidEmailEntred =  /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/.test(emailAddress1)
        if(isValidEmailEntred){
            const checkEmailVerified_Ext = AccountService.checkEmailVerified_Ext(
                emailAddress1,
                authHeader
            );
            showProgressDialog(platformMessages.loading, checkEmailVerified_Ext, true);
            checkEmailVerified_Ext.then((res) => {
                hideProgressDialog(platformMessages.loading, checkEmailVerified_Ext, true);
                if(res === true){
                    _.set(account, 'emailVerified_Ext.value', true);
                    _.set(account, 'emailAddress_ML.value', emailAddress1);
                }
                else{
                    _.set(account, 'emailVerified_Ext.value', false);
                    _.set(account, 'emailAddress_ML.value', emailAddress1 + ' ');
                }
            }).catch((e) => {
                clearBlockAlerts('invalidEmail');
                _.set(account, 'emailAddress_ML.value', emailAddress1);
                _.set(account, 'emailVerified_Ext.value', false);
                hideProgressDialog(platformMessages.loading, checkEmailVerified_Ext, true);
                console.log(e);
                window.scrollTo(0, 0);
            });
        }
    };

    const emailTrim = ( event ) => {
        if(event.emailAddress1.value){
            let emailAddress1 =  event.emailAddress1.value;
            if(emailAddress1 !== "" && emailAddress1 !== undefined){
                emailAddress1 = emailAddress1.trim();
                event.emailAddress1.value = emailAddress1;
            }
        }
    }

    const loadDeclinePopUpModel = useCallback((buttonOption,quote) => {
        if (_.isNil(quote)) {
            quote = submissionVM.value;
        }
        const componentProps = {
            title: translator(messages.declineLetters),
            uiProps: emailAddressModalPopup.pageContent,
            actionBtnLabel: messages.continue,
            cancelBtnLabel: messages.cancel,
            onSaveAction: () => {
                //saveEmailAddress()
                onGenerateDeclineDocument(buttonOption)
            },
            onCancelAction: () => {
                return false;
            },
            overrideProps: {
                emailAddressField: {
                    label: translator(messages.emailAddress),
                    placeholder: translator(messages.yourEmailAddressHere),
                    required: buttonOption === 'emailNoticeButton' ? _.isUndefined(_.get(submissionVM, 'baseData.primaryNamedInsured_ML.emailAddress1.value')): false,
                    onBlur:(value, path) => {validateEmailAddress(submissionVM.baseData.primaryNamedInsured_ML)},
                    onFocus:(event) => emailTrim(submissionVM.baseData.primaryNamedInsured_ML, event),
                    visible: buttonOption === 'emailNoticeButton'
                },
                downloadDeclineHeader:{
                    visible: buttonOption === 'downloadFormButton'
                },
            },
            viewModel: submissionVM,
            buttonType: 'outlined'
        };
        //load pop up model
        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        ).then((results) => {
            if (results === 'cancel') {
                return _.noop();
            }
            return history.push(`/accounts/${submissionData.baseData.accountNumber}/summary`);
        })
    });
//US993539
    const onUploadDocumentClicked = useCallback((contingency) => {
        openFileUploadDialog(contingency);
    }, []);
    const openFileUploadDialog = (contingency) => {
            let policyInfo = submissionVM?.value
            const componentProps = {
                showHeader: false,
                uiProps: mlDocumentsUploadPopupMetadata.componentContent,
                actionBtnLabel: _.upperCase(translator(MLDocumentsUploadPopupMsg.continue)),
                cancelBtnLabel: MLDocumentsUploadPopupMsg.cancelModal,
                disableButton: (vm) => !(_.get(vm, 'aspects.valid') && vm, _.get(vm, 'aspects.subtreeValid')),
                viewModelService,
                authHeader,
                CustomComponent: MLDocumentsUpload,
                overrideProps: {
                    policyNumber: submissionVM?.policyNumber?.value ?submissionVM?.policyNumber.value :jobID,
                    isAgent: true,
                    policy: policyInfo,
                    contingencyName: contingency?.title,
                    isFromPolicyChangeScreen:true,
                    contingency,
                    setIsFileUploadDone,
                    refreshPreBindContingencyData,
                    setcontingencies,
                    refreshOpenOrClosedPreBindContingencies
                },
                onSaveAction: () => {
                    return false;
                },
                buttonType: 'secondary'
            };
    
            modalApi.showModal(
                <FormModalPopover {...componentProps} />
            );
        }
    
    const overrideProps  = {
        parentUwIssuesDiv: {
            visible: !hidePanel && hasApprovedOrBlockingUWIssues() ||  contingencies.length > 0,
            className: hasWrapper() ? 'ml-uw-issues-panel-wrapper vertical-spacing-30 ml-uw-issues-panel' : 'vertical-spacing-30 ml-uw-issues-panel'
        },
        nonApprovedIcon: {
            visible: hasNonApprovedUWIssues() || contingencies.length > 0,
            className: !hasNonApprovedUWIssues() ? 'ml-alert icon-ml-alert-icon uw-issues-error-icon ml-uw-issues-panel-all-approved' : 'ml-alert icon-ml-alert-icon uw-issues-error-icon'
        },
        showRefreshLoadingDiv: {
            visible: showRefreshLoading
        },
        refreshLoadingButton: {
            visible: !showRefreshLoading
        },
        reviewAndApproveP: {
            visible: canApproveAllIssues() && (!allUwIssuesWithoutReferralsApproved() || !allUwIssuesWithReferralsApproved())
        },
        uwIssuesPanel: {
            visible: isUWIssuesPanelVisible
        },
        uwWrapperNonRefer: {
            visible: showUwIssuesNonRefer,
            className: allUwIssuesWithoutReferralsApproved() ? 'uw-wrapper ml-alert vertical-spacing-20 ml-section slim'
                : 'uw-wrapper ml-alert vertical-spacing-20 ml-alert-error ml-alert-error-local'
        },
        uwIssuesPanelContingencies:{
            visible: isUWIssuesPanelVisible && contingencies.length >0 ,
        },
        uwWrapperContigencyNonRefer:{
            visible: contingencies.length >0,
        },
        nonReferSpanIcon: {
            visible: !allUwIssuesWithoutReferralsApproved() || contingencies.length >0
        },
        nonReferUwIssueIterable: {
            data: getUwIssuesWithoutReferrals(),
            className: allUwIssuesWithoutReferralsApproved() ? 'margin-left-0' : ''
        },
        uwWrapperReferral: {
            visible: showUwIssuesRefer,
            className: allUwIssuesWithReferralsApproved() ? 'uw-wrapper ml-alert vertical-spacing-20 ml-section slim'
                : 'uw-wrapper ml-alert vertical-spacing-20 ml-alert-error ml-alert-error-local'
        },
        uwWrapperDeclination: {
            visible: isUWIssuesPanelVisible && (isDeclineInBatch_ML()?.length > 0),
            className:  'uw-wrapper ml-alert vertical-spacing-20 ml-section slim uwWrapperDeclination'
        },
        coloradoAlternative: {
            visible: isUWIssuesPanelVisible && (isDeclineInBatch_ML()?.length > 0) && showColoradoExclusion(),
        },
        referSpanIcon: {
            visible: !allUwIssuesWithReferralsApproved()
        },
        referPapproval: {
            content: (
                <FormattedMessage
                    {...messages.approvalCall}
                    values={{
                        number: <strong>{isIAorPCSorMetGAAgent() ? translator(messages.iaOrPcsNumber) : translator(messages.nonIaOrPcsNumber)}</strong>
                    }}
                />)
        },
        referUwIssueIterable: {
            data: getUwIssuesWithReferrals(),
            className: allUwIssuesWithReferralsApproved() ? 'margin-left-0' : ''
        },
        uwIssuesPanelLink: {
            content: isUWIssuesPanelVisible ? translator(messages.hideAllIssues) : translator(messages.showAllIssues)
        },
        referDeclineSpanIcon: {
            className:"ml-alert uw-issues-warning-icon pull-left"
        },
        emailNoticeButton:{
            onClick: ()=> loadDeclinePopUpModel('emailNoticeButton'),
        },
        readtoCustomerButton:{
            onClick: ()=> loadDeclinePopUpModel('readtoCustomerButton'),
            visible: !readForCustomerDisabledForTX() || !isReadToCustomerButtonEnabled()
        },
        downloadFormButton:{
            onClick: ()=> loadDeclinePopUpModel('downloadFormButton'),
        },
        nonReferUwIssueIterableComponennt: {
            content: [(
            <div>
                {
                    contingencies?.map((value) => {
                    return (
                        <div id="parentUwIssueItemNonRefer" className="uw-issue">
                            <div id="spanContainer">
                                <span id="reasonP" className="body-copy font-weight-bold">
                                    {"Contingency :"}
                                </span>
                                <p id="showBundleIssues" className="body-copy display-inline-block"></p>
                                <p id="descrP" className="body-copy display-inline-block">
                                    {value.description_ML}
                                </p>
                                <span
                                    id="btnDividerSpanNonRefer"
                                    className="uw-issue-button-divider"
                                >{" "}</span>
                                <a
                                    id="uploadProofBtn"
                                    type="button"
                                    onClick={(e) => onUploadDocumentClicked(value)}
                                    className="vertical-spacing-0"
                                >
                                    {"Upload Proof"}
                                </a>
                            </div>
                        </div>
                    );
                })
                }
            </div>
            )]
        },
        ...generateNonReferredOverrides(),
        ...generateReferredOverrides()
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onRefreshUwIssues: refreshUWIssues,
            onToggleUWIssuesPanel: toggleUWIssuesPanel
        }
    }
    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            {...resolvers} />
    );
};

MLUWIssuesPanelComponent.propTypes = {
    uwIssues: PropTypes.arrayOf(PropTypes.shape({})),
    jobID: PropTypes.string,
    publicID: PropTypes.string,
    hideIfAllApproved: PropTypes.bool,
    rejectedIssuesAreQuoteBlocking: PropTypes.bool,
    wrapped: PropTypes.bool,
    showIssuesForBundle: PropTypes.bool,
    refreshBundleUwIssues: PropTypes.func,
    approvedAllQuoteBlockingUwIssuesCallback: PropTypes.func,
    approvedAllBlockingUWIssuesCallback: PropTypes.func,
    blockingUWIssuesPresentCallback: PropTypes.func,
    afterIssuesRefreshedCallback: PropTypes.func,
    pendingContingencies: PropTypes.arrayOf(PropTypes.shape({})),
};

MLUWIssuesPanelComponent.defaultProps = {
    uwIssues: [],
    showIssuesForBundle: false,
    approvedAllQuoteBlockingUwIssuesCallback: _.noop,
    approvedAllBlockingUWIssuesCallback: _.noop,
    blockingUWIssuesPresentCallback: _.noop,
    pendingContingencies: [],
}

export default MLUWIssuesPanelComponent;